import SubQuestionManagement from './subQuestionManagement'
export default SubQuestionManagement
